<div>
    <app-tool-bar [title]="'Roll Number Configuration'" [iconName]="'pi-id-card'" [isAdd]="true"
        (handleAdd)="handleAddRollNumberConfig()"></app-tool-bar>
</div>

<div class="p-4 overflow-auto h-[85vh]">
    <p-table [value]="dataSource" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
        (onLazyLoad)="loadData($event)" [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined"
        [loading]="loading">

        <!-- Header -->
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 5rem">S.No</th>
                <th *ngFor="let col of columns">
                    {{ col.header }}
                </th>
            </tr>
        </ng-template>

        <!-- Body -->
        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr>
                <td>
                    <div style="margin-left: 5px;">
                        {{ rowIndex + 1 }}
                    </div>
                </td>
                <td *ngFor="let col of columns">
                    <ng-container [ngSwitch]="col.type">
                        <ng-container *ngSwitchCase="'actions'">
                            <div *ngIf="!loading" (click)="setRollNumberConfigData(rowData)">
                                <p-menu [tabindex]="undefined" #menu [model]="rollNumberConfigActionItems"
                                    [popup]="true" appendTo="body">
                                </p-menu>
                                <button pButton type="button" (click)="menu.toggle($event)" icon="pi pi-ellipsis-v"
                                    class="p-button-rounded p-button-text"></button>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchDefault>
                            <ng-container *ngIf="col.field.includes('.')">
                                <ng-container *ngIf="col.field === 'department.name'">
                                    {{ rowData?.department?.name || 'N/A' }}
                                </ng-container>

                                <ng-container *ngIf="col.field === 'academic_year.year'">
                                    {{ rowData?.academic_year?.year_name || 'N/A' }}
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="col.field === 'counter'">
                                {{ rowData?.counter }}
                            </ng-container>
                            <ng-container *ngIf="!col.field.includes('.') && col.field !== 'counter'">
                                {{ rowData[col.field] || 'N/A' }}
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </td>
            </tr>
        </ng-template>

        <!-- Loading -->
        <ng-template pTemplate="loading">
            <tr>
                <td colspan="3" class="text-center">
                    <p-progressSpinner></p-progressSpinner>
                </td>
            </tr>
        </ng-template>

        <!-- Empty message -->
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="columns.length + 1" class="no-data">
                    <p>No records found</p>
                </td>
            </tr>
        </ng-template>

    </p-table>
</div>

<!-- Add Roll Number Config Dialog -->
<p-dialog [modal]="true" *ngIf="isAddRollNumberConfig" [(visible)]="isAddRollNumberConfig"
    [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }" closable="false" [style]="{ width: '60vw' }"
    [draggable]="false" [resizable]="false">
    <app-create-roll-number [type]="'Create'" [allDepartments]="allDepartments" [allAcademicYears]="allAcademicYears"
        (closeDialog)="isAddRollNumberConfig = false" (reload)="reloadData()"></app-create-roll-number>
</p-dialog>

<!-- Edit Roll Number Config Dialog -->
<p-dialog [modal]="true" *ngIf="isEditRollNumberConfig" [(visible)]="isEditRollNumberConfig"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" closable="false" [style]="{ width: '50vw' }"
    [draggable]="false" [resizable]="false">
    <app-create-roll-number [type]="'Update'" [rollNumberConfigData]="rollNumberConfigData"
        [allDepartments]="allDepartments" [allAcademicYears]="allAcademicYears"
        (closeDialog)="isEditRollNumberConfig = false" (reload)="reloadData()"></app-create-roll-number>
</p-dialog>

<!-- Delete Roll Number Config Dialog -->
<p-dialog [modal]="true" *ngIf="isDeleteRollNumberConfig" [(visible)]="isDeleteRollNumberConfig"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" closable="false" [style]="{ width: '30vw' }"
    [draggable]="false" [resizable]="false">
    <app-delete-roll-number [rollNumberConfigData]="rollNumberConfigData"
        (closeDialog)="isDeleteRollNumberConfig = false" (reload)="reloadData()"></app-delete-roll-number>
</p-dialog>